<mat-toolbar class="flex items-center" color="primary">
    <a routerLink="/secure/home"><img class="max-[500px]:size-16! h-[2rem]! max-[500px]:size-16! h-[2rem]! px-1"
            style="height: 2rem !important; width: initial !important;" alt="DRÄXLMAIER LOGO"
            src="img/drx-logo-white.svg" /></a>
    <div class="flex items-center">
        <span class="max-[1030px]:text-lg max-[1300px]:text-xl text-wrap pl-4">D-ACCESS
        </span>
    </div>
    <div class="ml-auto grid grid-flow-col auto-cols-min">
        <div class="ml-auto items-center">
            <span>
                <button mat-icon-button (click)="logout()">
                    <mat-icon>logout</mat-icon>
                </button>
            </span>
        </div>
    </div>
</mat-toolbar>